import { switchAccount } from 'platform/bridge-methods';

import { root } from '../root';

export const platform = root.createDomain();

export const switchAccountFx = platform.createEffect(switchAccount);
